import {commonActions} from '../../actions/commonActions';
import {serviceSetList} from '../../actions/serviceActions';
import {connect} from 'react-redux';
import List from '../../components/service/ServiceList';
import {API_FETCH} from '../../services/FetchService';



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

const list = (value) => {
    return (dispatch, getState) => {
        API_FETCH.get('service-type',{params: value}).then(list => {
            dispatch(serviceSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.service.list,
        common       : state.common,
        initialValues: state.service.targetItem
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);